export const JobDetailConfig: Record<string, string>[] = [
  {
    key: "title",
    displayTitle: "Title"
  },
  {
    key: "postingStatus",
    displayTitle: "Job status"
  },
  {
    key: "briefText",
    displayTitle: "Brief Description"
  },
  {
    key: "jobRole",
    displayTitle: "Job role"
  },
  {
    key: "jobDuration",
    displayTitle: "Job duration"
  },
  {
    key: "jobType",
    displayTitle: "Job type"
  },
  {
    key: "jobLevel",
    displayTitle: "JobLevel"
  },
  {
    key: "jobLocation",
    displayTitle: "Location"
  },
  {
    key: "totalPay",
    displayTitle: "Total pay"
  },
  {
    key: "currencyCode",
    displayTitle: "Currency"
  },
  {
    key: "hiringManager",
    displayTitle: "Hiring Manager"
  },
  {
    key: "preferredStartDate",
    displayTitle: "Preferred Start Date"
  },
  {
    key: "jobImage",
    displayTitle: "Job Image Link"
  },
  {
    key: "description",
    displayTitle: "Job Description"
  }
];
